import React from 'react';
import {Typography} from "antd";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    render() {
        if (this.state.hasError) {
            // Error path
            return (
                <>
                    <Typography.Title level={3}>Something went wrong.</Typography.Title>
                </>
            );
        }

        return this.props.children;
    }
}